import {useSelector} from "react-redux";
import {dashboardStore} from "../store/dashboardPageStore";

export interface IDashboardUserCurrentLevelLogic {
  currentLevel?: number;
}

export const useDashboardUserCurrentLevelLogic = (): IDashboardUserCurrentLevelLogic => {
  const currentLevel = useSelector(() => dashboardStore.getUserSummary().currentLevel);
  return {
    currentLevel,
  };
}
